import * as React from "react";
import { ViewerTestIdTemplate } from "~/sharedComponents/const";
import { InlinedComponentProps } from "~/sharedComponents/inlineEdit/withInlineEdit";
import { MultiSelect, MultiSelectProps } from "~/sharedComponents/select/multiSelect/MultiSelect";
import {
    InlineMultiSelectViewer,
    MultiSelectValuesView,
} from "~/sharedComponents/select/multiSelect/MultiSelectValuesView";
import { WithEditModeEditorProps } from "~/sharedHOC/withEditMode/withEditMode";
import { epFormat } from "~/utils/epFormat";

export type InlineMultiSelectProps<TItem> = WithEditModeEditorProps &
    InlinedComponentProps<Omit<MultiSelectProps<TItem>, "onChange">> &
    Pick<React.ComponentProps<typeof MultiSelectValuesView>, "initialOptions" | "ChipsComponent">;

export const InlineMultiSelect = <TItem,>({
    onChangeAction,
    onSelect, // not to pass it to List if MultiSelect is wrapped with withEditMode
    onToggle, // do not pass through because it calls escapeEditMode, see withInlineEdit.inlinePopupSelectOnToggleOpen
    updateAction, // don't pass it because saveOnChange is on
    onUnmountAction,
    cancelAction,
    prevValue,
    ...props
}: InlineMultiSelectProps<TItem>) => {
    const viewerTestId = epFormat(ViewerTestIdTemplate, props.fieldPlaceholder);

    return (
        <MultiSelect {...props} inline={true} showOverTrigger={true} onChange={onChangeAction}>
            {({ isOpened }) => (
                <InlineMultiSelectViewer
                    {...props}
                    isOpened={isOpened}
                    data-testid={viewerTestId}
                    // hide "unselect" button for viewer
                    onChange={null}
                />
            )}
        </MultiSelect>
    );
};
